import React, { FC, useRef } from "react";
import { DebounceInput } from "react-debounce-input";
import styled from "@emotion/styled";
import { Box, Button, TextField, TextFieldProps, Typography } from "@mui/material";
import { SearchIcon } from "icons";
import { CLICK_SEARCH_INIT } from "utills/events";
import ReactGA from "react-ga4";
import { Link, LinkProps } from "react-router-dom";
import { SearchTag } from "layouts/MainLayout/components/Search";
import { useWindowWidth } from "@react-hook/window-size";
import { isEmpty } from "lodash-es";
interface SearchInputProps {
  placeholder?: string;
  value: any;
  onChange: any;
  customchip: any;
  searchChip: any;
  handleGetFilterPosts?: (data: SearchTag | undefined) => void;
  inputRef?: any;
}

const SearchInput: FC<SearchInputProps> = ({ inputRef, ...props }) => {
  const width = useWindowWidth();
  const divRef = useRef<HTMLDivElement>(null);


  const handleFocusIn = () => {
    if (divRef.current) {
      divRef.current.style.border = "2px solid #0072e5";
    }
  }

  const handleFocusOut = () => {
    ReactGA.event(CLICK_SEARCH_INIT, {});
    if (divRef.current) {
      divRef.current.style.border = "";
    }
  }

  return (
    <SearchInputContainer ref={divRef} data-tut="reactour__search">
      <SearchIcon />
      <Container>
        {props.searchChip && width > 960 ? props.customchip : null}
        <DebounceInput
          onBlur={handleFocusOut}
          onFocus={handleFocusIn}
          // onBlur={(e) => {
          //   e.target.focus();
          // }}
          // onFocus={() => {
          //   ReactGA.event(CLICK_SEARCH_INIT, {});
          // }}
          element={TextField}
          fullWidth
          type="search"
          placeholder={
            props.searchChip.length >= 1
              ? ""
              : "Search for People, Clubs, Stocks, Sectors or Topics"
          }
          minLength={1}
          debounceTimeout={300}
          {...props}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none"
              },
            },
          }}
          inputProps={{
            ref: inputRef
          }}
        />
        {props.searchChip?.length >= 1 && width > 540 ? (
          <Button onClick={() => props.handleGetFilterPosts?.(undefined)}>
            <Typography
              color="primary"
              variant="caption"
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              pr="10px"
            >
              Search
            </Typography>
          </Button>
        ) : null}
      </Container>
    </SearchInputContainer>
  );
};

export default SearchInput;

const Container = styled(Box)`
  display: flex;
  padding-left: 35px;
`;

const SearchInputContainer = styled.div`
  width: 100%;
  position: relative;
  background-color: ${({ theme }: any) => theme.palette.background.default};
  border-radius: 6px;
  border: 1.5px solid transparent;

  &:hover {
    border: 1px solid black;
  }
  // &:focus-within {
  //   border: 2px solid #0072e5;
  // }

  svg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 8px;
    margin: auto;
    stroke-width: 2px;
  }

  input {
    padding-left: 10px;
    &:focus {
      border-color: red;
    }
  }
  .MuiInputBase-root {
    height: 44px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: transparent;
    &:hover {
      border-color: transparent;
    }
  }
`;
